import { html } from "haunted";

export const ArgdownMark = () => {
  return html`
    <style>
      .argdown-mark {
        font-size: 0.8rem;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-content: center;
        align-items: center;
        position: absolute;
        top: 3px;
        left: 3px;
        z-index: 10;
        background-color: rgba(256, 256, 256, 0.8);
        padding-right: 0.8rem;
        border-radius: 3px;
        color: var(--argdown-logo-color);
        fill: var(--argdown-logo-color);
        text-decoration: none;
      }
      .argdown-mark .icon {
        width: 2rem;
        height: 2rem;
      }
      .argdown-mark .name {
        display: inline-block;
        font-weight: bold;
        font-family: Arial, Helvetica, sans-serif;
        text-decoration: none;
      }
    </style>
    <a href="https://argdown.org" class="argdown-mark"
      ><svg
        class="icon"
        width="100%"
        height="100%"
        viewBox="0 0 32 32"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        xml:space="preserve"
        xmlns:serif="http://www.serif.com/"
        style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:1.41421;"
      >
        <g transform="matrix(1,0,0,1,-0.948929,-0.0447248)">
          <path
            d="M21.4,16.695L24.949,16.695L16.949,25.67L8.949,16.695L12.51,16.695L12.51,6.42L15.51,8.295L15.51,20.06L16.949,21.675L18.4,20.047L18.4,8.295L21.4,6.42L21.4,16.695Z"
          />
        </g>
      </svg>
      <span class="name">argdown</span>
    </a>
  `;
};
